import { FC } from 'react'
import ModuleWrapper2020 from 'components/features/pfm/ModuleWrapper2020/ModuleWrapper2020'
import { CardBlock } from 'components/features/pfm/Blocks/Blocks'
import styles from 'components/features/coaching/advisorPublicPage/ModulePreset/ModulePreset.styl'
import cn from 'classnames'

type ModulePresetProps = {
  title: string
  className?: string
  noCard?: boolean
}
export const ModulePreset: FC<ModulePresetProps> = (props) => {
  const { children, className, noCard, title } = props

  return (
    <ModuleWrapper2020
      title={ title }
      card={ false }
    >
      { noCard && children }
      { !noCard && (
        <CardBlock
          corners='all'
          forceRoundedCorners
          shadowTheme='soft'
          className={ cn(styles.modulePreset, className) }
          noBorders
        >
          { children }
        </CardBlock>
      )}
    </ModuleWrapper2020>
  )
}
